/**
 * App events. Today they only go to the console in dev; later an adapter forwards them to the
 * backend (usage_events table) so tokens can be decremented and stats shown.
 */
export type AppEvent =
  | { name: 'round_started'; level: string; bMax: number }
  | { name: 'round_finished'; level: string; bMax: number; score: number; solved: number; answered: number; durationMs: number }
  | { name: 'settings_changed'; key: string };

type Listener = (e: AppEvent) => void;
const listeners = new Set<Listener>();

export function track(e: AppEvent): void {
  for (const l of listeners) l(e);
  if (import.meta.env.DEV) console.debug('[event]', e);
}
export function onEvent(l: Listener): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}
